import { TmInputType } from '@treasury/presentation/components/jh-ui/tm-input';
import { AlphaNumericValidator } from './alphaNumeric.validator';
import { CurrencyValidator } from './currency.validator';
import { EmailValidator } from './email.validator';
import { IpAddressValidator } from './ipAddress.validator';
import { LengthValidator } from './length.validator';
import { NumericValidator } from './numeric.validator';
import { PhoneValidator } from './phone.validator';
import { RequiredValidator } from './required.validator';

export class ValidationResult {
    constructor(isValid: boolean = true, errorMessage: string = '') {
        this.isValid = isValid;
        this.errorMessage = errorMessage;
    }

    public isValid: boolean;

    public errorMessage?: string;
}

export interface ValidatorOptions {
    maxLength?: number;
    minLength?: number;
    required?: boolean;
}

export function validateValueByType(type: TmInputType, value: string, options: ValidatorOptions) {
    if (!value) {
        return new RequiredValidator().validate(value, options);
    }

    if (type === 'alpha-numeric') {
        return new AlphaNumericValidator().validate(value, options);
    }
    if (type === 'numeric') {
        return new NumericValidator().validate(value, options);
    }
    if (type === 'email') {
        return new EmailValidator().validate(value, options);
    }
    if (type === 'tel') {
        return new PhoneValidator().validate(value, options);
    }
    if (type === 'ip') {
        return new IpAddressValidator().validate(value, options);
    }
    if (type === 'currency') {
        return new CurrencyValidator().validate(value, options);
    }

    // Do base validations after all other validations
    return validateBaseValidation(value, options);
}

function validateBaseValidation(value: string, options: ValidatorOptions) {
    const lengthResult = new LengthValidator().validate(value, options);
    if (!lengthResult.isValid) {
        return lengthResult;
    }
    return new RequiredValidator().validate(value, options);
}
